import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { VideosState } from './types';

export const getters: GetterTree<VideosState, RootState> = {
  //
};
